import fetch from 'cross-fetch';
import { sameOriginRequestPolicy } from '../actions';
import { LoginHubConsumeTokenAction } from './login-hub-consume-token-action';

export class RemoteConsumeTokenAction {
	private readonly baseUrl: string | null;

	constructor(baseUrl: string | null) {
		this.baseUrl = baseUrl;
	}

	action: LoginHubConsumeTokenAction = async (token: string): Promise<boolean> => {
		const base: string = this.baseUrl || '';

		try {
			const response = await fetch(`${base}/api/login-hub/consume-token`, {
				...sameOriginRequestPolicy,
				method: 'POST',
				headers: {
					'Content-Type': 'application/json'
				},
				body: JSON.stringify({ token: token }),
			});
			if (!response.ok) {
				console.error('User login failed with ', response.status);
				return false;
			}
			return true;
		} catch (e: unknown) {
			throw new Error('unexpected');
		}
	};
}
